import { Component, Vue } from 'vue-property-decorator';
import '@/app/app-error-handler';

@Component
export default class App extends Vue {}
